import React, { Component } from "react";
import AvisoModalServicio from "./AvisoModalServicio";
import AvisoModal from "./AvisoModal";

class AvisoModalControlador extends Component {
    state = {
        config: null,
    };

    componentDidMount() {
        this.unsubscribe = AvisoModalServicio.subscribe((config) => {
            this.setState({ config });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }

    handleClose = () => {
        this.setState({ config: null });
    };

    render() {
        const { config } = this.state;
        if (!config)
            return null;
        return (
            <AvisoModal
                isOpen={true}
                tipo={config.tipo}
                titulo={config.titulo}
                mensaje={config.mensaje}
                onClose={this.handleClose}
            />
        );
    }
}

export default AvisoModalControlador;